(function($){
  $(function(){
    //PCのとき 電話番号 無効
    if($(window).innerWidth() > 768){
      $(".-telink").on('click', function(){
        return false;
      });
    }else{}

    var getTranslate;
    var slideWidth;
    
    //swiper
    var storeSlide = new Swiper('.custom-ranking',{
      loop: true,
      slidesPerView: 'auto',
      //speed: 1200,
      speed: 6900,
      spaceBetween: 24,
      slideToClickedSlide: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
  });
    $(window).on('resize',function(){
      storeSlide.autoplay.paused = false;
    });
  });

  $(window).on('load', function(){
    refresh_subtotal();
  });
  function refresh_subtotal(){
    var price = $('.subtotal-price').text();
    var rmtxt = price.replace(/,|¥/g, '');
    var result = rmtxt * 1.1;
    var pricetax = Math.floor(result);
    var pricesimulate = pricetax.toLocaleString();
    $('#pricesimulate').text("¥" + pricesimulate + "（税込）");
    setTimeout(function(){
      refresh_subtotal();
    },500);
  }

})(jQuery);